// utils/getTailwindUtility.js
import tw from "../../tailwind.config.js";

/** Resolve a value from the tailwind config */
const themeGetter = (name) => tw.theme[name];

/** Core resolver (unchanged) */
const getTailwindUtility = (name) => {
  const utility = tw[name] || tw.theme[name] || tw.theme.extend[name];

  if (!utility) {
    throw new Error(`Tailwind utility "${name}" not found`);
  }
  return typeof utility === "function" ? utility(themeGetter) : utility;
};

export default getTailwindUtility;
/**
 * Parse any Tailwind size token (px, rem, %, number) into a **Number** in pixels.
 * – “230px”   ➜ 230
 * – "14rem"   ➜ 14 × root font-size   (defaults to 16 px)
 * – "100%"    ➜ NaN  (caller decides what to do)
 * – 400       ➜ 400
 */
export const getTailwindUtilityAsNumber = (
  name,
  key,
  { baseRem = 16 } = {}
) => {
  const raw =
    key !== undefined ? getTailwindUtility(name)[key] : getTailwindUtility(name);

  if (typeof raw === "number") return raw;

  if (typeof raw !== "string") return NaN;

  if (raw.endsWith("px")) {
    return parseFloat(raw);
  }
  if (raw.endsWith("rem")) {
    return parseFloat(raw) * baseRem;
  }
  // anything else (%, vw, etc.) – return NaN so callers can fallback
  return NaN;
};
